import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Apiservice } from '../../../../services/api.service';
import { NicaAnagraficaComponent } from '../../../../components/nica-anagrafica/nica-anagrafica.component';
import { DxDataGridComponent } from 'devextreme-angular';
import { alert, confirm } from 'devextreme/ui/dialog';
import { ComponentService } from '../../../../services/component.service';
import { environment } from '../../../../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, of, Subject, throwError, timer } from 'rxjs';
import { catchError, concatMap, exhaustMap, finalize, map, mergeMap, retryWhen, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { Utenteservice } from '../../../../services/utente.service';
import { IModelloStampa, ModelliStampaService } from '../../../../services/modelli-stampa.service';
import { UtilityService } from '../../../../services/utility.service';
import { NgxSpinnerService } from 'ngx-spinner';

export interface GetEsitoRes {
  error: boolean
  errors: ErrorsPerStampa[]
  result: string
}

export interface ErrorsPerStampa {
  errorText: string
  guidTrans: string
  operatore: string
  dataOraOperazione: string
  aziendaLavoro: string
  annoGestione: string
  progressivo: string
  registroRentri: string
  errorTextFull: string
}

@Component({
  selector: 'app-popup-esportazione-rentri',
  templateUrl: './popup-esportazione-rentri.component.html',
  styleUrls: ['./popup-esportazione-rentri.component.css']
})
export class PopupEsportazioneRentriComponent implements OnInit, OnDestroy {
  @ViewChild('elencoGridDaElaborare', { static: false }) elencoGridDaElaborare: NicaAnagraficaComponent
  @ViewChild('EsportazioneGridElaborati', { static: false }) EsportazioneGridElaborati: NicaAnagraficaComponent
  @Input() filterGridDaElaborare: string
  @Input() filterGridElaborati: string
  @Input() reletedData: { [key: string]: any }
  @Input() selectedRegistro: string
  registri: { [key: string]: any }[] = []
  selectedStatoOperazioni: 1 | 2 = 1
  isGuidtrans: boolean | undefined = undefined
  isrecuperato: boolean | undefined = undefined
  isGuidverifica: boolean | undefined = undefined
  statoVerifica: boolean | undefined = undefined
  statoFirma: boolean | undefined = undefined
  statoArchiviazione: boolean | undefined = undefined
  isLoadingStatus: number = 0
  statoOperazioni: { key: number, label: string }[] = [
    {
      key: 1,
      label: 'Da elaborare'
    },
    {
      key: 2,
      label: 'Elaborati'
    },
  ]
  isDhFirma: boolean = false
  isRentriFirma: boolean = false
  modelloRegistroRentri
  canReadStat: boolean = true
  private guidtrans: string
  private guidverifica: string
  constructor(private apiService: Apiservice, private componentService: ComponentService, private utility: UtilityService, private httpClient: HttpClient, private utenteService: Utenteservice, private modelliStampa: ModelliStampaService, private readonly spinner: NgxSpinnerService) {
    this.apiService.GetApi("registrorifiuti?$filter=(registroRentri ne null and registroRentri ne '')").then((res: any[]) => {
      if (res && res['items']) this.registri = res['items']
    })
  }
  ngOnDestroy(): void {

  }
  ngOnInit(): void {
    if (this.reletedData) {
      this.filterGridDaElaborare = `?idRegistro=${this.reletedData['id']}`
      this.filterGridElaborati = `?idRegistro=${this.reletedData['id']}`
      this.selectedRegistro = this.reletedData['id'] || null
      this.apiService.GetApi(`RenEsportazioni/CheckModuli?idRegistro=${this.reletedData['id']}`).then((res: { rentri: boolean, dh: boolean }) => {
        this.isDhFirma = res.dh
        this.isRentriFirma = res.rentri
      })
      this.apiService.GetApi(`ModellodiStampa/GetByGUID/bb33baa2-fe89-467d-885d-fdcd3a547bfa`).then((data: IModelloStampa) => {
        this.modelloRegistroRentri = data || null
        console.log('modelloRegistroRentri', data)
      });
    }

  }

  onSelectionChangedRegistro(event) {
    console.log(event)
    if (this.canReadStat) this.defaultStato()
    if (event.selectedItem) this.reletedData = event.selectedItem
  }

  onValueChangedRegistro(event) {
    console.log('onValueChangedRegistro', event)
    if (event.previousValue) {
      if (this.selectedStatoOperazioni === 1) { if (this.canReadStat) this.defaultStato() }
      this.filterGridDaElaborare = `?idRegistro=${event.value}`
      this.filterGridElaborati = `?idRegistro=${event.value}`
      if (this.elencoGridDaElaborare) {
        this.elencoGridDaElaborare.refresh()
        this.elencoGridDaElaborare.griglia.instance.deselectAll()
      }
      if (this.EsportazioneGridElaborati) {
        this.EsportazioneGridElaborati.refresh()
        this.EsportazioneGridElaborati.griglia.instance.deselectAll()
      }
    }
  }
  onSelectionChangedStato(event) {
    // if (event.selectedItem) {
    //   this.defaultStato()
    //   console.log(event)
    //   this.selectedStatoOperazioni = event.selectedItem.key
    // }
    if (this.canReadStat) this.defaultStato()
  }

  onAllEventGrid(event) {
    if (!this.isDhFirma) {
      if (this.EsportazioneGridElaborati && this.EsportazioneGridElaborati.griglia) { this.EsportazioneGridElaborati.griglia.instance.columnOption('dh', 'visible', false); }
    }
    if (this.elencoGridDaElaborare && this.elencoGridDaElaborare.griglia) {
      this.elencoGridDaElaborare.griglia.instance.columnOption('dh', 'visible', false);
    }

    if (event.name === "onCellPrepared") {
      if (event.dataField === "dh") {
        if (this.isDhFirma) {
          if (event.data.isinviatodh) {
            event.cellElement.innerHTML = '✅'
          }
        }
      }
      if (event.dataField === "nomefilexml" && this.elencoGridDaElaborare) {
        if (event.data && event.data.nomefilexml) {
          event.cellElement.innerHTML = '✅'
        }
      }
    }


    if (event.name === "onContentReady") {
      console.log('ssssssssssssssssssssss', this.elencoGridDaElaborare)
      if (this.elencoGridDaElaborare) this.elencoGridDaElaborare.griglia.instance.selectRows([0], true)
      if (this.EsportazioneGridElaborati) this.EsportazioneGridElaborati.griglia.instance.selectRows([0], true)
    }
    if (event && event.name && event.name === "onSelectionChanged") {
      if (this.selectedStatoOperazioni === 1) { if (event.data['guidtrans'] !== null) { this.readStato(event.data) } else this.defaultStato() }
      else { if (this.canReadStat) this.readStato(event.data) }
      console.log('onAllEventGrid', event)
    }
    if (event.name === "onCellPrepared" && event.rowType === 'data') {
      if (event.dataField === 'stato') {
        if (this.selectedStatoOperazioni === 1) event.cellElement.innerHTML = `Da Elaborare`
        else event.cellElement.innerHTML = `Elaborato`
      }
    }
  }
  optionalButtonGrid(event) {
    console.log('optionalButtonGrid', event)


    if (event.name === "elaboraRentri") {
      if (event.row && event.row.data) {
        if (this.selectedStatoOperazioni === 1) { if (event.row.data['guidtrans'] !== null) { this.readStato(event.row.data) } else this.defaultStato() }
        console.log(event.row.data)
        let messagge = ''
        let isVisibleAlert = true
        if (this.canReadStat) {
          this.elabora(event.row.data).pipe(take(1)).subscribe({
            next: (result: any) => { },
            error: result => {
              console.error('Errore nella sequenza:', result);
              if (result && result.error) {
                messagge = `<p>L'elaborazione del blocco non è andata a buon fine</p><p>${result.errorText}</p>`;
                isVisibleAlert = typeof result.isStampa === 'boolean' ? !result.isStampa : true
              }
              if (result && result.index) {
                if (result.index === 1) this.isGuidtrans = false
                if (result.index === 2) this.isrecuperato = false
                if (result.index === 3) this.isGuidverifica = false
                if (result.index === 4) this.statoVerifica = false
                if (result.index === 5) this.statoFirma = false
                if (result.index === 6) this.statoArchiviazione = false
              }
              if (messagge) {
                if (isVisibleAlert) alert(messagge, 'Errore durante l\'elaborazione');
              } else {
                if (isVisibleAlert) alert(`L'elaborazione del blocco è stata completata correttamente`, 'Elaborazione completata');
              }
              if (this.elencoGridDaElaborare) this.elencoGridDaElaborare.refresh()
            },
            complete: () => {
              if (messagge) {
                if (isVisibleAlert) alert(messagge, 'Errore durante l\'elaborazione');
                if (this.elencoGridDaElaborare) this.elencoGridDaElaborare.refresh()
              } else {
                alert(`L'elaborazione del blocco è stata completata correttamente`, 'Elaborazione completata');
                if (this.elencoGridDaElaborare) this.elencoGridDaElaborare.refresh()
              }
            }
          });
        }
        return
      }
    }
    if (event.name === "exportXml") {
      if (event.row && event.row.data && event.row.data.id) {
        const id = event.row.data.id
        this.apiService.GetApi(`RenEsportazioni/${id}`).then((res: any) => {
          console.log('RenEsportazioni', res)
          const docXml = res.documento
          console.log(atob(docXml))
          const blob = new Blob([atob(docXml)], { type: "application/xml" });
          const url = URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          link.download = `${res.nomefilexml}.xml`;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          URL.revokeObjectURL(url); // cleanup


        })
      }
    }
    if (event.name === "exportPdf") {
      if (event.row && event.row.data && event.row.data.id) {
        const id = event.row.data.id
        this.apiService.GetApi(`RenEsportazioni/GetElencoMovimentiById/${id}`).then((datiPdf: any) => {
          console.log('RenEsportazioni', datiPdf)
          this.modelliStampa.generaPDF(datiPdf, this.modelloRegistroRentri, 'preview').then((id) => {
            this.componentService.outputComponent.subscribe(currentOutput => {
              if (currentOutput.guid == id) {
                console.log('currentOutput--->', currentOutput)
                if (currentOutput.name == "close") {
                  this.componentService.destroyCurrentOpenPopUpByGuid(id);
                  this.componentService.destroyOutputComponent();
                }
              }
            })
          })
        })
      }
    }
    if (event.name === "conservazione") {
      if (event.row && event.row.data && event.row.data.id) {
        const id = event.row.data.id
        this.spinner.show()
        try {
          this.apiService.PutApi(`RenEsportazioni/${id}/InviaInConservazioneDH`, null).then((res: any) => {
            if (res.error) return alert(res.errorText, "Attenzione!")
            alert(res.result, "Successo.")
            this.EsportazioneGridElaborati.refresh()
            this.statoFirma = true
          })
        } catch { } finally {
          this.spinner.hide()
        }
      }
    }
  }
  optionalBottoneToolbarGrid(event) {
    console.log('optionalBottoneToolbarGrid', event)
  }
  onClickEsporta(event) {
    if (this.reletedData !== null) {
      const guid = Math.random().toString().replace("0.", "");
      const instanceData = {
        reletedData: this.reletedData,
        guid
      }
      this.componentService.setNewPopUp(guid, 'PopupEsportazioneFilesComponent', null, '800', null, instanceData, false, true, `Esporta PDF/XML Registro: ${this.reletedData.descrizione}`, 'center')
    }
  }
  onClickSync(event) {
    confirm('<p>Si desidera sincronizzare i dati sull\'hub?</p><p>L\'operazione potrebbe richiedere del tempo</p>', 'Attenzione').then((res) => {
      return
    })
  }
  defaultStato() {
    this.isGuidtrans = undefined
    this.isrecuperato = undefined
    this.isGuidverifica = undefined
    this.statoVerifica = undefined
    this.statoFirma = undefined
    this.statoArchiviazione = undefined
  }
  readStato(data: { [key: string]: any }) {
    if (!this.canReadStat) { return }
    this.defaultStato();

    // Step 1: estraggo i valori grezzi
    const guidtrans = data['guidtrans'];
    const isrecuperato = data['isrecuperato'];
    const guidverifica = data['guidverifica'];
    const isverificato = data['isverificato'];
    const hash = data['hash'];

    // Step 2: eseguo la logica sequenziale
    this.isGuidtrans = guidtrans !== null;

    if (this.isGuidtrans === true) {
      this.isrecuperato = isrecuperato === true;

      if (this.isrecuperato === true) {
        this.isGuidverifica = guidverifica !== null;

        if (this.isGuidverifica === true) {
          this.statoVerifica = isverificato === true;

          if (this.statoVerifica === true) {
            const hashPresente = hash !== null;
            this.statoFirma = hashPresente;
            this.statoArchiviazione = hashPresente;
          }
        }
      }
    }

    if (this.isDhFirma) {
      this.statoFirma = data['isinviatodh'];
    }
  }
  async stampaErrore(resError: GetEsitoRes) {
    this.isrecuperato = false
    const datiUtente = this.utenteService.InfoDatiUtenteConnesso
    const dataCorrente = new Date().toLocaleString('it', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' })
    const plusData = {
      operatore: datiUtente.userName,
      dataOraOperazione: dataCorrente,
      aziendaLavoro: datiUtente.descr_licenza,
      annoGestione: `Anno ${datiUtente.annoSelected}`
    }
    const errori = resError.errors.map((errore) => {
      return { ...errore, ...plusData }
    })
    const modello: IModelloStampa = await this.httpClient.get<IModelloStampa>(environment.BASE_API_URL.concat(`ModellodiStampa/GetByGUID/f66f6020-a8bc-4186-9ca3-9b7566284252`)).toPromise();

    confirm("La seguente operazione ha generato uno o più errori. <br /> Procedere alla visualizzazione di essi?", "Errori").then(
      (res) => {
        if (res)
          this.modelliStampa.generaPDF(errori, modello, 'preview');
      }
    );

    return
  }
  //! -----------------------------------------------------------------------
  private elabora(body: { [key: string]: any }): Observable<Object> {
    const EndPoint = environment.BASE_API_URL
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return of(null).pipe(
      take(1),
      concatMap(() => {
        this.isLoadingStatus++
        if (body['guidtrans'] !== null) {
          this.isGuidtrans = true;
          return of(body['guidtrans'])
        }
        this.canReadStat = false
        return this.httpClient.post(EndPoint + 'RenEsportazioni/InvioRentri', body, { headers }).pipe(catchError(() => {
          return throwError({ error: true, errorText: `Errore IR-1-01`, index: 1 })
        }),
          concatMap((res: any) => {
            if (res.error) return throwError({ error: true, errorText: `Errore IR-1-02: ${res.errorText}`, index: 1 })
            this.isGuidtrans = true;
            return of(res.result);
          })
        );
      }),
      concatMap((guidtrans: any) => {
        console.warn(guidtrans);
        this.isLoadingStatus++;
        if (body['guidtrans'] !== null && body['isrecuperato']) {
          this.isrecuperato = true;
          return of({ guidtrans: body['guidtrans'] })
        }
        this.canReadStat = false
        return this.httpClient.get(
          EndPoint + `RenEsportazioni/GetEsitoInvioRentri?idRegistro=${this.reletedData['id']}&guidTrans=${guidtrans}`,
          { headers }
        ).pipe(catchError(() => {
          return throwError({ error: true, errorText: `Errore IR-2-01`, index: 2, isStampa: false })
        }),
          concatMap((res: any) => {
            if (res.error) {
              this.stampaErrore(res);
              return throwError({ error: true, errorText: 'Errore IR-2-02', index: 2, isStampa: true })
            }
            this.isrecuperato = true;
            return of({ guidtrans, GetEsitoInvioRentri: res.result });
          })
        );
      }),
      concatMap((response: { guidtrans: string, GetEsitoInvioRentri: string }) => {
        this.isLoadingStatus++
        if (body['guidtrans'] !== null && body['guidverifica'] !== null) {
          this.isGuidverifica = true;
          return of({ guidtrans: body['guidtrans'], guidverifica: body['guidverifica'] })
        }
        this.canReadStat = false
        return this.httpClient.get(EndPoint + `RenEsportazioni/VerificaXMLRentri?idRegistro=${this.reletedData['id']}&guidTrans=${response.guidtrans}`, { headers }).pipe(
          catchError(() => {
            return throwError({ error: true, errorText: `Errore IR-3-01`, index: 3 })
          }),
          concatMap((res: any) => {
            if (res.error) {
              this.stampaErrore(res);
              return throwError({ error: true, errorText: 'Errore IR-3-02', index: 3, isStampa: true })
            }
            this.isGuidverifica = true;
            return of({ guidtrans: response.guidtrans, guidverifica: res.result });
          })
        );
      }),
      concatMap((response: { guidtrans: string, guidverifica: string }) => {
        this.guidtrans = response.guidtrans
        this.guidverifica = response.guidverifica
        this.isLoadingStatus++
        if (body['guidtrans'] !== null && body['guidverifica'] !== null && body['isverificato'] !== null) {
          this.statoVerifica = true;
          return of({ guidtrans: body['guidtrans'], guidverifica: body['guidverifica'] })
        }
        this.canReadStat = false
        return this.httpClient.get(EndPoint + `RenEsportazioni/GetEsitoVerificaXMLRentri?idRegistro=${this.reletedData['id']}&guidTrans=${response.guidtrans}&guidVerifica=${response.guidverifica}`, { headers }).pipe(
          catchError(() => {
            return throwError({ error: true, errorText: `Errore IR-4-01`, index: 4 })
          }),
          concatMap((res?: any) => {
            if (res.error) return throwError({ error: true, errorText: `Errore IR-4-02: ${res.errorText}`, index: 4 })
            this.statoVerifica = true;
            return of(res);
          })
        );
      }),
      concatMap((res: any) => {
        this.isLoadingStatus++
        this.canReadStat = false
        if (this.isDhFirma) {
          return this.httpClient.get(EndPoint + `RenEsportazioni/FirmaFileXmlConFirmaDH?idRegistro=${this.reletedData['id']}&guidTrans=${this.guidtrans}&guidVerifica=${this.guidverifica}`, { headers }).pipe(
            catchError(() => {
              return throwError({ error: true, errorText: `Errore IR-5-01-DH`, index: 5, })
            }),
            concatMap((res: any) => {
              if (res.error) return throwError({ error: true, errorText: `Errore IR-5-02-DH: ${res.errorText}`, index: 5 })
              this.statoFirma = true;
              return of(res);
            })
          );
        }
        if (this.isRentriFirma && !this.isDhFirma) {
          return this.httpClient.get(EndPoint + `RenEsportazioni/FirmaFileXmlConFirmaRentri?idRegistro=${this.reletedData['id']}&guidTrans=${this.guidtrans}&guidVerifica=${this.guidverifica}`, { headers }).pipe(
            catchError(() => {
              return throwError({ error: true, errorText: `Errore IR-5-01-R`, index: 5, })
            }),
            concatMap((res: any) => {
              if (res.error) return throwError({ error: true, errorText: `Errore IR-5-02-R: ${res.errorText}`, index: 5 })
              this.statoFirma = true;
              return of(res);
            })
          );
        }
        return throwError({ error: true, errorText: `Non sono presenti firme valide per l\'invio dei dati`, index: 5, })
      }),
      concatMap(() => {
        if (this.isDhFirma) {

          return this.httpClient.get(
            `${EndPoint}RenEsportazioni/GetEsitoFileXmlConFirmaDH?idRegistro=${this.reletedData['id']}&guidTrans=${this.guidtrans}&guidVerifica=${this.guidverifica}`,
            { headers }
          ).pipe(
            // intercetta errori HTTP
            catchError((err) => {
              if (err instanceof HttpErrorResponse && err.status !== 425) {
                // tutti gli errori diversi da 425 li butti fuori subito
                return throwError({
                  error: true,
                  errorText: `Errore IR-6-01-DH`,
                  index: 6,
                });
              }
              // se è 425 lo lasci gestire a retryWhen → qui ritorna throwError per innescare retry
              return throwError(err);
            }),
            // retryWhen intercetta solo gli errori che hai rimandato su
            retryWhen(errors =>
              errors.pipe(
                mergeMap((err, retryIndex) => {
                  if (err instanceof HttpErrorResponse && err.status === 425) {
                    // aspetta 2 secondi prima di ritentare
                    if (retryIndex < 5) {
                      // aspetta 2s, poi ritenta (max 5 volte)
                      return timer(2000);
                    }
                    // superato il limite → errore definitivo
                    return throwError({
                      error: true,
                      errorText: `L'operazione ha richiesto troppo tempo ti preghiamo di riprovare fra qualche minuto`,
                      index: 6,
                    });
                  }
                  // qualsiasi altro errore chiude lo stream
                  return throwError({ error: true, errorText: `Errore IR-6-02-DH`, index: 6 });
                })
              )
            ),
            concatMap((res: any) => {
              if (res.error) {
                return throwError({
                  error: true,
                  errorText: `Errore IR-6-03-DH: ${res.errorText}`,
                  index: 6,
                });
              }
              this.statoArchiviazione = true;
              return of();
            })
          );
        }
        if (!this.isDhFirma && this.isRentriFirma) {
          this.statoArchiviazione = true
          return of()
        }
        return throwError({ error: true, errorText: `Errore IR-6-00-DH`, index: 6 })
      }),
      catchError(err => {
        return throwError(err);
      }),
      finalize(() => {
        this.isLoadingStatus = 0;
        this.canReadStat = true
      })
    )
  }
  apriInfoFirma() {
    const titolo = `Utilizzo Firma Tecnica Rentri`
    const messagge = `
      <h5>
        AVVISO IMPORTANTE AI FINE DELLA CORRETTA TENUTA DEL REGISTRO CRONOLOGICO DI C/S
      </h5>
      <p class="text-wrap" style="max-width: 900px;text-align: left;"> La procedura di “immodificabilità/firma” del registro
        cronologico, nei termini previsti dalla
        normativa (art.
        190,
        comma 1 lettere a,b,c e d del D.lgs 152/2006), in mancanza della piattaforma DH Waste (Firma qualificata, backup
        e
        Conservazione all-in-one) utilizzerà in alternativa la <i class="text-decoration-underline">firma tecnica di dominio rilasciata dalla CA Rentri</i> così
        come
        previsto dalle istruzioni riportate al seguente
        <b>
          <a href="https://supporto.rentri.gov.it/aswsWeb/search?query=la%20firma%20rentri%20%C3%A8%20utile%20per%20firmare%20il%20registro%20cronologicio?&idProduct=RENTRI&userRole=rentriud#"
            target="_blank">link</a>
        </b>
      </p>
      <p class="text-wrap" style="max-width: 900px;text-align: left;">
        E’ da tener presente che la <i class="text-decoration-underline">firma tecnica <b>RENTRI</b> non è una firma qualificata</i> pertanto i file XML prodotti
        potrebbero
        non superare i test di verifica di validità previsti dai più comuni sistemi di firma (Vol poste italiane,
        Infocamere, Aruba, Namirial, etc. vedi <b><a
          href="https://ec.europa.eu/digital-building-blocks/DSS/webapp-demo/validation" target="_blank">link</a></b> ) e,
           in assenza di una firma qualificata, sarà necessario inviarli in conservazione nel più breve tempo
        possibile
        così come previsto dalle stesse istruzioni pubblicate sul portale R.E.N.T.Ri. e delle quali di seguito
        riportiamo
        una sintesi:
        </br>
        </br>
        <i>
          “Si aggiunge che, come previsto dalla regolamentazione tecnica in materia di tenuta e conservazione dei
          registri,
          laddove l’operatore, in base a proprie scelte di natura organizzativa, intenda archiviare il file, che
          rappresenta
          il registro elettronico, prima del trasferimento al sistema di conservazione a norma, il medesimo file dovrà
          essere
          firmato digitalmente con firma qualificata.
        </br>
          A tal proposito si rammenta che <i class="text-decoration-underline">il certificato digitale di tipo sigillo elettronico rilasciato dal RENTRI non
            può assolvere alla funzione di firma qualificata.</i>”
        </i>
        </p>
      <p class="text-wrap" style="max-width: 900px;text-align: left;">
        La procedura che segue quindi provvederà ad inoltrare i movimenti a RENTRI così come previsto dal DM 59 - art.15
        -
        comma 1, a produrre il file del registro in formato XML, a firmarlo apponendo la firma tecnica del RENTRI e ad
        archiviarlo in locale sul proprio sistema.</br>
        <b class="text-decoration-underline">RentrinCloud NON INVIERA’ IN CONSERVAZIONE IL REGISTRO XML</b>. L’obbligo di conservazione resta a cura del cliente
        che
        dovrà provvedere al versamento nel proprio sistema di conservazione a norma seguendo scrupolosamente le regole
        (Metadati, manuale di conservazione, nomina del responsabile della conservazione etc.) dettate da CAD (codice
        dell’amministrazione digitale).</br>
        Ricordiamo infine che RENTRI non è un sistema di conservazione a norma.</br>
        Per ulteriori informazioni contattare il nostro help desk o quello del partner di riferimento.
      </p>
      <blockquote class="p-0 m-0 blockquote-footer" style="max-width: 900px;text-align: left;">Lo staff di RentrinCloud.it</blockquote>`
    alert(messagge, titolo)
  }

}